import { render, staticRenderFns } from "./EnergyTrendsYear.vue?vue&type=template&id=20494aca&scoped=true&"
import script from "./EnergyTrendsYear.vue?vue&type=script&lang=js&"
export * from "./EnergyTrendsYear.vue?vue&type=script&lang=js&"
import style0 from "./EnergyTrendsYear.vue?vue&type=style&index=0&id=20494aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20494aca",
  null
  
)

export default component.exports